export default __webpack_public_path__ + "static/media/pop-icon.fd7eb9ba.webp";